export default __webpack_public_path__ + "static/media/startCamera.86f651e2.png";